<template>
  <div>
    <v-layout row style="align-items: center;">
      <v-flex style="margin-right: 2em" xs1>
        <service-as-badge :service-id="serviceId"/>
      </v-flex>
      <v-flex style="margin-right: 2em" xs2>
        <div class="unimInlineBlock mr-3">
          <v-tooltip bottom>
              <span slot="activator" :style="{color: getEventColor('ChangeRequested')}">
                {{requestedQuantity}}
              </span>
            Requested all time
          </v-tooltip>

          <edit-requested-service-form :case-id="caseId"
                                       :service-id="serviceId"
                                       :current-requested-quantity="requestedQuantity"
                                       :current-executed-quantity="executedQuantity"
                                       style="display: inline-block"/>
        </div>

        <div class="unimInlineBlock">
          <v-tooltip bottom>
              <span slot="activator" :style="{color: getEventColor('ChangeExecuted')}">
                {{executedQuantity}}
              </span>
            Executed all time
          </v-tooltip>

          <edit-executed-service-form :case-id="caseId"
                                      :service-id="serviceId"
                                      :current-requested-quantity="requestedQuantity"
                                      :current-executed-quantity="executedQuantity"
                                      style="display: inline-block"/>
        </div>

        <div class="unimInlineBlock">
          <v-tooltip bottom>
              <span slot="activator" :style="{color: getEventColor('ChangeChecked')}">
                {{checkedQuantity}}
              </span>
            Checked all time
          </v-tooltip>
        </div>
      </v-flex>

      <v-flex style="margin-right: 2em" xs2>
        <v-tooltip bottom>
          <span slot="activator">
            <pretty-amount :amount="itemPrice"/>
          </span>
          Item price / {{itemPrice.source}}
        </v-tooltip>
        /
        <v-tooltip bottom>
          <span slot="activator" :style="{color: getEventColor('ChangeRequested')}">
            <pretty-amount :amount="fullRequestedPrice"/>
          </span>
          Full requested price
        </v-tooltip>
        /
        <v-tooltip bottom>
          <span slot="activator" :style="{color: getEventColor('ChangeExecuted')}">
            <pretty-amount :amount="fullExecutedPrice"/>
          </span>
          Full executed price
        </v-tooltip>
      </v-flex>

      <v-flex xs3>
        <div class="unimInlineBlock">
          <delete-case-service-form :case-id="caseId"
                                    :service-id="serviceId"
                                    class="unimInlineBlock"
                                    v-if="canBeDeleted"/>

          <v-btn small icon
                 @click="toggleExpand"
                 class="unimInlineBlock">
            <v-icon small>fa-info</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <v-layout v-if="showTable">
      <case-service-log-details
        :case-id="caseId"
        :log="filteredLog"/>
    </v-layout>
  </div>
</template>

<script>
  import CaseServiceLogDetails from './CaseServiceLogDetails'
  import ServiceAsBadge from '../../Ui/mcc/ServiceAsBadge'
  import PrettyAmount from '../../Ui/PrettyAmount'
  import DeleteCaseServiceForm from "./DeleteCaseServiceForm";
  import EditExecutedServiceForm from './EditExecutedServiceForm'
  import EditRequestedServiceForm from './EditRequestedServiceForm'
  import bigInt from "big-integer"
  import {getEventColor} from "./caseServiceLogUtils";

  export default {
    name: 'case-service-log-item',
    components: {
      CaseServiceLogDetails,
      ServiceAsBadge,
      DeleteCaseServiceForm,
      EditExecutedServiceForm,
      EditRequestedServiceForm,
      PrettyAmount
    },
    props: {
      caseId: {
        type: String,
        required: true
      },
      serviceId: {
        type: String,
        required: true
      },
      itemPrice: {
        type: Object,
        required: true
      },
      oldRequestedQuantity: {
        type: Number,
        required: true
      },
      requestedQuantity: {
        type: Number,
        required: true
      },
      executedQuantity: {
        type: Number,
        required: true
      },
      checkedQuantity: {
        type: Number,
        required: true
      },
      log: {
        type: Array,
        required: true
      },
      eventTypes: {
        type: Array,
        required: true
      },
      operationEnabled: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        expanded: false
      }
    },
    methods: {
      toggleExpand() {
        this.expanded = !this.expanded
      },
      getEventColor(event) {
        return getEventColor(event)
      }
    },
    computed: {
      filteredLog() {
        return _.filter(this.log, it => _.includes(this.eventTypes, it.event));
      },
      showTable() {
        return this.expanded
      },
      canBeDeleted() {
        return this.operationEnabled && (this.requestedQuantity !== 0 || this.executedQuantity !== 0)
      },
      fullRequestedPrice() {
        let fullExecutedAmount = bigInt(this.itemPrice.amount * 100).multiply(this.requestedQuantity);
        return {
          amount: Number(fullExecutedAmount.toString()) / 100,
          currency: this.itemPrice.currency
        }
      },
      fullExecutedPrice() {
        let fullExecutedAmount = bigInt(this.itemPrice.amount * 100).multiply(this.executedQuantity);
        return {
          amount: Number(fullExecutedAmount.toString()) / 100,
          currency: this.itemPrice.currency
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/CaseServiceLogItem.vue